module.exports = __webpack_public_path__ + "img/gray-web-seminar.3e9d3b0d.png";